import React from 'react';

import { UiButtonBase } from '@/components/ui/ButtonBase';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { removeAllDataAndStartOver } from '@/utils/removeAllDataAndStartOver';

import { TitleStyles } from './Title.styles';

export const Title: React.FC = () => {
  return (
    <TitleStyles>
      <UiButtonBase
        onClick={removeAllDataAndStartOver}
        expand="full"
        className="btn-remove-all-data"
      >
        Remove all data and start over
      </UiButtonBase>

      <OnboardingTitle>Devmode Paywall. Select plan.</OnboardingTitle>
    </TitleStyles>
  );
};
